import {cssTheme} from '@logistics-frontend/blocks'
import {css} from '@logistics-frontend/blocks/theme/css'
import {breakpoints, spacing} from '@logistics-frontend/blocks/theme/theme'

export const classes = {
  root: css`
    background-color: ${cssTheme.default.day.backgroundMinor};
    block-size: ${spacing(25)};
    border-radius: ${spacing(2)};
    padding: ${spacing(3)};
    position: relative;
    transition: background-color 0.2s ease-in;

    &:hover {
      background-color: ${cssTheme.default.day.controlMinor};
    }
  `,
  row: css`
    flex-grow: 0;
  `,
  radio: css`
    ${cssTheme.default.day.controlMinor.token}: ${cssTheme.default.day.background};
  `,
  hovered: css`
    cursor: pointer;
  `,
  checked: css`
    background-color: ${cssTheme.default.day.controlMinor};
  `,
  date: css`
    margin-block-start: ${spacing(1)};
    color: #617387; // @todo - что за цвет??
  `,
  logo: css`
    margin-block-end: auto;

    ${breakpoints.down('sm')} {
      margin: 0;
      margin-inline-end: ${spacing(1.25)};
    }
  `,
}
